export const LOGIN_USER_MUTATION = `
   mutation LoginUser ($email: String!, $password: String!, $invite_token: String) {
        loginUser(email: $email, password: $password, invite_token: $invite_token) {
            user_name
            token
            new_user
       }
   }
`;

export const REGISTER_USER_MUTATION = ` 
    mutation RegisterUser ($first_name: String!, $last_name: String!, $email: String!, $phone: String, $password: String!) {
        registerUser(first_name: $first_name, last_name: $last_name, phone: $phone, email: $email, password: $password)
    }
`;

export const FORGOT_USER_PASSWORD = `
    mutation ForgotPassword($email: String!, $invite_token: String) {
        forgotPassword(email: $email, invite_token: $invite_token)
    }
`;

export const RESET_USER_PASSWORD = `
    mutation ResetPassword($email: String!, $token: String!, $password: String!, $password_confirmation: String!, $invite_token: String) {
        resetPassword(email: $email, token: $token, password: $password, password_confirmation: $password_confirmation, invite_token: $invite_token) {
            user_name
            token
            new_user
        }
    }
`;

export const LOGOUT_USER_MUTATION = `
    mutation LogoutUser { 
        logoutUser 
    }
`;

export const VERIFY_USER_MUTATION = ` 
    mutation VerifyUser($code: String!, $email: String!, $invite_token: String) {
        verifyUser(code: $code, email: $email, invite_token: $invite_token) {
        user_name
        token
        new_user
        verified
        redirect_url
        }
    }
`;

export const RESEND_VERIFYCODE_MUTATION = `
    mutation resendUserVerification($email: String!) {
        resendUserVerification(email: $email)
    }
`;

export const INVITED_USER_MUTATION = `
    mutation InviteCode($first_name : String!, $last_name : String!, $token: String!, $password: String!, $password_confirmation: String! ) {
        inviteCode(first_name: $first_name, last_name : $last_name, token: $token, password: $password, password_confirmation: $password_confirmation) {
            user_name
            token
            new_user
            verified
        }
    } 
`;

export const INVITE_CODE_STATUS_MUTATION = `
    mutation InviteCodeStatus( $token: String!) {
        inviteCodeStatus( code: $token ) {
            status
            logo
            workspace_name
            channel {
                handle
                type
            }
            code
            new_user
            url
            invited_by {
                first_name
                last_name
                email
                avatar
            }
        }
    }
`;